import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import MicroProfile from '../micro-profiles/micro-profile';
import ErrorBoundary from '../../shared/error-boundary';
import Loading from '../../shared/loading';

export default class FollowingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contributors: props.contributors,
    };
  }

  handleRemoveUnfollowedContributor(index) {
    this.setState(prevState => ({
      contributors: [
        ...prevState.contributors.slice(0, index),
        ...prevState.contributors.slice(index + 1),
      ],
    }));
  }

  renderContributor(contributor, index) {
    const keys = [
      'id', 'name', 'organization', 'position', 'slug', 'first_name',
      'last_name', 'profile_picture_url', 'areas_of_expertise',
      'active_partnership',
    ];
    return (
      <MicroProfile
        key={contributor.id}
        profile={{
          ..._.mapKeys(_.pick(contributor, keys), (v, k) => _.camelCase(k)),
          canPostWires: true,
        }}
        isProfileFollowedByCurrentUser
        onUnfollow={() => this.handleRemoveUnfollowedContributor(index)}
      />
    );
  }

  render() {
    return (
      <ErrorBoundary>
        <Loading ref={el => (this.loading = el)} variant="full-page">
          <section className="following-list">
            {this.state.contributors.map((c, index) => this.renderContributor(c, index))}
            {!this.state.contributors.length && (
              <p>You&apos;re not currently following any contributors</p>
            )}
          </section>
        </Loading>
      </ErrorBoundary>
    );
  }
}

FollowingList.propTypes = {
  contributors: PropTypes.arrayOf(PropTypes.shape({})),
};

FollowingList.defaultProps = {
  contributors: [],
};
